import React from 'react';
import PropTypes from 'prop-types';
import CarouselItem from './CarouselItem';
import Slider from 'epic-react-slick';

export default class Carousel extends React.PureComponent {
    static propTypes = {
        slides: PropTypes.object,
        mobile: PropTypes.bool
    };

    render() {
        const settings = {
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            dots: false,
            arrows: true,
            slidesToScroll: 1
        };
        const {slides, mobile} = this.props;
        const {subTitle, title, items} = slides;

        let carouselWrapper = '';
        if (items) {
            const amount = items.length || 1;
            if (amount === 1) {
                const cItem = items[0] || '';
                carouselWrapper = (
                    <div className="single-slide">
                        <CarouselItem
                            type={cItem.type}
                            title={cItem.title}
                            description={cItem.description}
                            buttonLabel={cItem.buttonLabel}
                            buttonLink={cItem.buttonLink}
                            image={cItem.imageURL}
                            bgImage={cItem.bgImageURL}
                            bgImageMobile={cItem.bgImageMobileURL}
                            bgColor={cItem.bgColor}
                            mobile={mobile}
                        />
                    </div>
                );
            } else if (amount > 1) {
                carouselWrapper = (
                    <Slider className="carousel-wrapper" {...settings}>
                        {items !== undefined && items.length > 0 ? (
                            items.map((item, index) => (
                                <div key={item.title}>
                                    <CarouselItem
                                        type={item.type}
                                        title={item.title}
                                        description={item.description}
                                        buttonLabel={item.buttonLabel}
                                        buttonLink={item.buttonLink}
                                        image={item.imageURL}
                                        bgImage={item.bgImageURL}
                                        bgImageMobile={item.bgImageMobileURL}
                                        bgColor={item.bgColor}
                                        mobile={mobile}
                                    />
                                </div>
                            ))
                        ) : (
                            <div />
                        )}
                    </Slider>
                );
            }
        }

        let sectionHeader = '';
        if (title !== undefined) {
            sectionHeader = (
                <div className="careers-section-header">
                    <h1>{title}</h1>
                    <div className="h2">{subTitle}</div>
                </div>
            );
        }

        return (
            <section className="careers-carousel">
                {sectionHeader}
                {carouselWrapper}
            </section>
        );
    }
}
